import { render, staticRenderFns } from "./Skip10BackwardIcon.vue?vue&type=template&id=d76569b2"
import script from "./Skip10BackwardIcon.vue?vue&type=script&lang=js"
export * from "./Skip10BackwardIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports